import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-return-report',
  templateUrl: './return-report.component.html',
  styleUrls: ['./return-report.component.scss']
})
export class ReturnReportComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  	
  }

}
